import * as React from 'react'
import Script from 'next/script'

export const HubspotHeadComponent = () => {
  return (
    <>
      <Script async={true} src="/static/hubspot.js" />
    </>
  )
}
